import Loader from '@preqin/ui-components/cjs/core/Loader';

import logo from './preqinLogoExternal.svg';

import style from './AppLoader.module.scss';

export const AppLoader = ({ isLoading }: { isLoading: boolean }) => (
  <div data-testid="loader">
    <Loader isLoading={isLoading} />
    <div>Loading Data...</div>
  </div>
);

export const PreqinLogo = () => (
  <div id="preqin-report-logo" className={style.preqinReportLogo}>
    <img className={style.logo} src={logo} width="50" height="50" alt="logo" />
    <div>Loading Data...</div>
  </div>
);
